import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useTotalTasksCount = () => {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const { data, error } = await supabase.rpc('get_total_tasks_count');
        if (!error && data !== null) {
          setCount(data as number);
        }
      } catch {
        // Non-critical, ignore
      }
    };

    // Defer this non-critical fetch to avoid blocking LCP
    const hasIdleCallback = typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function';
    const id = hasIdleCallback
      ? window.requestIdleCallback(() => {
          fetchCount();
        }, { timeout: 4000 })
      : window.setTimeout(() => {
          fetchCount();
        }, 4000);

    return () => {
      if (hasIdleCallback && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(id);
      } else {
        window.clearTimeout(id);
      }
    };
  }, []);

  return count;
};
